import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20251021-dompdf",
        datum: "21.10.2025",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.FEATURE,
        title: "PDF-Wandler: dompdf 3.1.2 verfügbar",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE, LizenzEnum.FREE],
        content: [
            "Um eure PDF-Dateien für Formulare oder bspw. Teilnahmebescheinigungen zu erzeugen, bietet HiOrg-Server nun die aktuelle Version des PDF-Wandlers dompdf 3.1.2 zur Auswahl an.",
            "Die neue Version beinhaltet neben erweiterter CSS-Unterstützung insbesondere diverese Fehlerbereinigungen bei der Positionierung von Texten."
            + " Dadurch kann es bei der Umstellung bestehender Dokumente auf 3.1.2 zu Verschiebungen kommen, die Korrekturen an der Vorlage notwendig machen.",
            "Die bisherigen Versionen werden daher vorerst weiterhin angeboten, so dass durch euch keinen Änderungen nötig sind."
        ],
        aktions: [],
    },
    {
        id: "20251021-bugfixes",
        datum: "21.10.2025",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.BUGFIX,
        title: "Diverse Fehlerbehebungen",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE],
        content: [
            "<ul>"
            + "<li>💸 Das Datenfeld Kontoinhaber erlaubt nun, dem SEPA-Standard entsprechend, bis zu 70 Zeichen.</li>"
            + "<li>🤝 Bei der Datenfreigabe zwischen Organisationen wurde eine Ausnahme korrigiert.</li>"
            + "<li>🎓 Das Handling von ehemaligen Ausbildungsstellen wurde verbessert.</li>"
            + "<li>🎓 Ein Problem beim Ändern der Gebühr von per API angelegten Teilnehmern wurde behoben.</li>"
            + "</ul>",
        ],
        aktions: [],
    },
];

export {
    insights,
};
